import { useEffect } from 'react'
import '../DocumentPage.css'

const InGameTesting = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>In-Game Testing</h1>
        <p className="lead">
          Deploy and test your Variable Modding System in a packaged game build.
        </p>

        <h2>Creating a Test Build</h2>
        <p>Package your project for testing:</p>
        <ol>
          <li>Go to <strong>File → Package Project</strong></li>
          <li>Select your target platform</li>
          <li>Choose the output directory</li>
          <li>Wait for the packaging process to complete</li>
        </ol>

        <h2>Running the Test Build</h2>
        <p>Launch your packaged game and verify:</p>
        <ul>
          <li>All variables load correctly on startup</li>
          <li>Variable modifications persist across sessions</li>
          <li>Performance is acceptable</li>
          <li>No errors appear in shipping builds</li>
        </ul>

        <h2>Testing Variable Persistence</h2>
        <h3>Save System Integration</h3>
        <p>Test that variables save and load correctly with your game's save system.</p>

        <h3>Multiplayer Testing</h3>
        <p>If applicable, verify variable synchronization in multiplayer scenarios.</p>

        <h2>Performance Testing</h2>
        <ul>
          <li>Monitor frame rates during variable access</li>
          <li>Check memory usage with large datasets</li>
          <li>Profile variable update operations</li>
        </ul>

        <h2>Final Checks</h2>
        <p>Before releasing:</p>
        <ul>
          <li>Test on all target platforms</li>
          <li>Verify all CSV files are included in the build</li>
          <li>Check for any console errors or warnings</li>
          <li>Validate data integrity after packaging</li>
        </ul>
      </div>
    </div>
  )
}

export default InGameTesting
